import { pageSectionEnum, type pageSectionType } from '../../components/pages/landing-page';
import { otherType } from '../types';

export const setMenuOpen = (menuOpen: boolean) => (dispatch: any) => {
	dispatch({
		type: otherType.menuOpen.dataAction,
		payload: menuOpen,
	});
};

export const setSubMenuOpen = (subMenuOpen: number) => (dispatch: any) => {
	dispatch({
		type: otherType.subMenuOpen.dataAction,
		payload: subMenuOpen,
	});
};

export const setPageSection = (pageSection: pageSectionType) => (dispatch: any) => {
	dispatch({
		type: otherType.pageSection.dataAction,
		payload: pageSection || pageSectionEnum.LANDING,
	});
};
